import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { IListItem } from '@pro/activity/testerClub/interface';
import styles from './index.module.less';
import Iconfont from '@base/lib/Iconfont';
import cn from 'classnames';
import ReviewFormContent from '@pro/activity/testerClub/ResultsContent/ReviewFormContent'
import { IUseEarlyAccessResults } from '@pro/activity/testerClub/useEarlyAccessResults'

type IProps = {
    results: IUseEarlyAccessResults
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ReviewFormModal: React.FC<IProps> = (props) => {

    const {
        open,
        setOpen,
        results
    } = props


    return (
        <Modal
            className={styles['modal-wrap']}
            destroyOnClose
            width={'542px'}
            centered
            open={open}
            onCancel={() => setOpen(false)}
            footer={false}
            closeIcon={<Iconfont className={cn(styles['close-icon'], 'icon-x')}/>}
        >
            <div
                id='js-review-form-warp'
                className={styles['content-wrap']}
            >
                <ReviewFormContent results={results}/>
            </div>

        </Modal>
    );
};

export default ReviewFormModal